import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import MonthlyReport from "./MonthlyReport";
import CandidateReport from "./CandidateReport";
import ClientReport from "./ClientReport";

type ReportType = "client" | "candidate" | "monthly" | null;

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState<ReportType>("client");

  const renderReportContent = () => {
    switch (selectedReport) {
      case "monthly":
        return <MonthlyReport />;
      case "candidate":
        return <CandidateReport />;
      case "client":
        return <ClientReport />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#e5e4fe",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          backgroundColor: "#e5e4fe",
          width: "100%",
          padding: "20px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Report Type Selector */}
        <Box
          sx={{
            display: "flex",
            backgroundColor: "#F5F5F5",
            borderRadius: "25px",
            padding: "4px",
            border: "1px solid #E0E0E0",
          }}
        >
          <Button
            onClick={() => setSelectedReport("client")}
            sx={{
              borderRadius: "20px",
              padding: "8px 24px",
              fontSize: "14px",
              fontWeight: "500",
              textTransform: "none",
              backgroundColor: selectedReport === "client" ? "#756DE9" : "transparent",
              color: selectedReport === "client" ? "#FFFFFF" : "#666666",
              minWidth: "120px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: selectedReport === "client" ? "#5a4dbf" : "#E8E8F0",
                color: selectedReport === "client" ? "#FFFFFF" : "#333333",
              },
              boxShadow: selectedReport === "client" ? "0px 2px 8px rgba(117, 109, 233, 0.3)" : "none",
            }}
          >
            Client
          </Button>
          <Button
            onClick={() => setSelectedReport("candidate")}
            sx={{
              borderRadius: "20px",
              padding: "8px 24px",
              fontSize: "14px",
              fontWeight: "500",
              textTransform: "none",
              backgroundColor: selectedReport === "candidate" ? "#756DE9" : "transparent",
              color: selectedReport === "candidate" ? "#FFFFFF" : "#666666",
              minWidth: "120px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: selectedReport === "candidate" ? "#5a4dbf" : "#E8E8F0",
                color: selectedReport === "candidate" ? "#FFFFFF" : "#333333",
              },
              boxShadow: selectedReport === "candidate" ? "0px 2px 8px rgba(117, 109, 233, 0.3)" : "none",
            }}
          >
            Candidate
          </Button>
          <Button
            onClick={() => setSelectedReport("monthly")}
            sx={{
              borderRadius: "20px",
              padding: "8px 24px",
              fontSize: "14px",
              fontWeight: "500",
              textTransform: "none",
              backgroundColor: selectedReport === "monthly" ? "#756DE9" : "transparent",
              color: selectedReport === "monthly" ? "#FFFFFF" : "#666666",
              minWidth: "120px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: selectedReport === "monthly" ? "#5a4dbf" : "#E8E8F0",
                color: selectedReport === "monthly" ? "#FFFFFF" : "#333333",
              },
              boxShadow: selectedReport === "monthly" ? "0px 2px 8px rgba(117, 109, 233, 0.3)" : "none",
            }}
          >
            Monthly
          </Button>
        </Box>
      </Box>

      {/* Content Section */}
      <Box
        sx={{
          padding: { xs: "20px", sm: "32px" },
          backgroundColor: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          width: "100%",
          flex: 1,
          maxWidth: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {renderReportContent()}
      </Box>
    </Box>
  );
};

export default Reports;

